// client/src/components/Shared/ActionsBar.js

export default function ActionsBar({ onRefi, onRenewal, onCashflow, onAdd }) {
  const base =
    "px-4 py-2 rounded-lg text-sm font-semibold tracking-wide text-white shadow-sm hover:shadow-md transition";

  return (
    <div className="flex gap-3 justify-start w-full mb-4">

      {/* PRIMARY ACTION — BRAND RED */}
      <button
        className={`${base} bg-[#CC0202] hover:bg-[#A50000]`}
        onClick={onRefi}
      >
        Refinance Check
      </button>

      {/* SECONDARY ACTIONS — BRAND CHARCOAL */}
      <button
        className={`${base} bg-[#262626] hover:bg-black`}
        onClick={onRenewal}
      >
        Renewal Strategy
      </button>

      <button
        className={`${base} bg-[#262626] hover:bg-black`}
        onClick={onCashflow}
      >
        Improve Cash Flow
      </button>

      <button
        className={`${base} bg-[#262626] hover:bg-black`}
        onClick={onAdd}
      >
        Add Property
      </button>
    </div>
  );
}
